import { LOADED, LOADING } from '../actionTypes/BazaarVoiceActionTypes';

const defaultState = {
    loaded: false,
    loading: false,
};

function BazaarVoiceReducer(state = defaultState, action) {
    switch (action.type) {
        case LOADED:
            return { ...state, loaded: true, loading: false };
        case LOADING:
            return { ...state, loading: true };
        default:
            return state;
    }
}

export default BazaarVoiceReducer;
